
<div class="preview-wrapper"
    [ngStyle]="{
        'transform': 'scale(' + scaleX + ', ' + scaleY + ')',
        'width': sceneWidth * scaleX + 'px',
        'height': sceneHeight * scaleY + 'px'
    }">
    <div
        class="virtual-bg"
        [ngClass]="{
            viewBackground0: sceneCheckeredBackground === '0',
            viewBackground1: sceneCheckeredBackground === '1',
            viewBackground2: sceneCheckeredBackground === '2',
            viewBackground3: sceneCheckeredBackground === '3'
        }" 

        [ngStyle]="{
            'width': sceneWidth + 'px',
            'height': sceneHeight + 'px'
        }">
    </div>
    <div id="fontLoader" style="position: absolute; visibility:hidden"></div>
    <div #component
        class="app-theme-dark"
        style="position: absolute;width: 100%; height: 100%;">
        <template #playercontainer></template>
    </div>
    <div name="htmlLayer" style="pointer-events: none"></div>
</div>


<!-- <studio-signage
    [scenes]="scenes"
    [resources]="resources"
    [schedules]="schedules"
    [transitions]="transitions"
    (onLoad)="onLoad($event)"
    (onUpdate)="onLoad($event)">
</studio-signage> -->